import React from 'react'
import { Container, Row, Col } from 'react-bootstrap';

const Block = () => {
    return (
        <div className='block'>
            <div className='max-width'>
                <Container>
                    <Row >
                        <Col className='bcol'>
                            <div className='bCard'>
                                <div className='bHead'>
                                    <div className='cCircle c1'>
                                        <img src='Union1.png' alt='card png' />
                                    </div>
                                </div>
                                <h1 className='h1'>1,000+</h1>
                                <div className='bp'>
                                    Student’s <br /> Community
                                </div>

                            </div>
                        </Col>
                        <Col className='bcol'>
                            <div className='bar'>

                            </div>
                        </Col>
                        <Col className='bcol'>
                            <div className='bCard'>
                                <div className='bHead'>
                                    <div className='cCircle c2'>
                                        <img src='Union2.png' alt='card png' />
                                    </div>
                                </div>
                                <h1 className='h2'>5,000+</h1>
                                <div className='bp'>
                                    Colleges and Universities
                                </div>

                            </div>
                        </Col>
                        <Col className='bcol'>
                            <div className='bar'>

                            </div>
                        </Col>
                        <Col className='bcol'>
                            <div className='bCard'>
                                <div className='bHead'>
                                    <div className='cCircle c3'>
                                        <img src='Union3.png' alt='card png' />
                                    </div>
                                </div>
                                <h1 className='h3'>500+</h1>
                                <div className='bp'>
                                    Courses covered
                                </div>

                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </div>
    )
}

export default Block;